import { AxiosRequestConfig } from 'axios';

import { urlParser } from '@hh.ru/browser-api-utils';

import { getServiceName } from './serviceName';

export const HHTM_SOURCE_HEADER = 'X-hhtmSource';
export const HHTM_FROM_HEADER = 'X-hhtmFrom';
export const HHTM_SOURCE_LABEL_HEADER = 'X-hhtmSourceLabel';
export const HHTM_FROM_LABEL_HEADER = 'X-hhtmFromLabel';

interface ReturnhhtmSourceHeaders {
    [HHTM_SOURCE_HEADER]: string;
    [HHTM_FROM_HEADER]: string;
    [HHTM_SOURCE_LABEL_HEADER]: string;
    [HHTM_FROM_LABEL_HEADER]: string;
}

const getHhtmHeaders = (url?: string): ReturnhhtmSourceHeaders | null => {
    if (!url) {
        return null;
    }

    const parsedUrl = urlParser(url);
    const serviceName = getServiceName();
    // Access to XMLHttpRequest at 'https://hhcdn.ru/pv' from origin 'https://hh.ru'
    // has been blocked by CORS policy: Request header field x-hhtmsource is not allowed
    // by Access-Control-Allow-Headers in preflight response.
    if (parsedUrl.hostname && parsedUrl.hostname !== window.location.hostname) {
        return null;
    }
    return {
        [HHTM_SOURCE_HEADER]: window.globalServiceVars[serviceName].analyticsParams?.hhtmSource ?? '',
        [HHTM_FROM_HEADER]: window.globalServiceVars[serviceName].analyticsParams?.hhtmFrom ?? '',
        [HHTM_SOURCE_LABEL_HEADER]: window.globalServiceVars[serviceName].analyticsParams?.hhtmFrom ?? '',
        [HHTM_FROM_LABEL_HEADER]: window.globalServiceVars[serviceName].analyticsParams?.hhtmFrom ?? '',
    };
};

const hhtmInterceptor = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const hhtmHeaders = getHhtmHeaders(config.url);

    if (hhtmHeaders) {
        // eslint-disable-next-line
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        config.headers.common = { ...hhtmHeaders, ...config.headers.common };
    }
    return config;
};

export default hhtmInterceptor;
